(ns minorodata.components.data-apps.utils
  (:require ["lucide-react" :refer [Carrot FolderKanban LayoutGrid Megaphone
                                    Shapes ShoppingCart Sparkle Users]]
            [clojure.string :as s]
            [re-posh.core :as re-posh]
            [ui.utils :refer [clsx]]))


(defn docs-url [& paths]
  (s/join "/" (concat ["https://minoro-ltd.github.io/data-apps-docs"] paths)))

(defn img-url [& paths]
  (str
   (s/join "/" (concat ["/img/data-apps"] paths))
   ".png"))

(def default-icon-props {:size 20 :strokeWidth 2.1 :class "block"})

(defn acquisition-icon [props]
  [:div (-> props
            (dissoc :icon-props)
            (update :class #(clsx "inline-block bg-[#DBA900]/20 text-[#DBA900] p-1 rounded-xs" %)))
   [:> Megaphone (-> default-icon-props
                     (merge (:icon-props props)))]])

(defn customers-icon [props]
  [:div (-> props
            (dissoc :icon-props)
            (update :class #(clsx "bg-[#408D71]/20 text-[#408D71] p-1 rounded-xs" %)))
   [:> Users (-> default-icon-props
                 (merge (:icon-props props)))]])

(defn agriculture-icon [props]
  [:div (-> props
            (dissoc :icon-props)
            (update :class #(clsx "bg-[#408D71]/20 text-[#408D71] p-1 rounded-xs" %)))
   [:> Carrot (-> default-icon-props
                  (merge (:icon-props props)))]])

(defn discovery-icon [props]
  [:div (-> props
            (dissoc :icon-props)
            (update :class #(clsx "bg-[#7D16E9]/20 text-[#7D16E9] p-1 rounded-xs" %)))
   [:> Sparkle (-> default-icon-props
                   (merge (:icon-props props)))]])

(defn management-icon [props]
  [:div (-> props
            (dissoc :icon-props)
            (update :class #(clsx "bg-[#3F9BA9]/20 text-[#3F9BA9] p-1 rounded-xs" %)))
   [:> FolderKanban (-> default-icon-props
                        (merge (:icon-props props)))]])

(defn products-icon [props]
  [:div (-> props
            (dissoc :icon-props)
            (update :class #(clsx "bg-[#4F6CE2]/20 text-[#4F6CE2] p-1 rounded-xs" %)))
   [:> ShoppingCart (-> default-icon-props
                        (merge (:icon-props props)))]])

(defn misc-icon [props]
  [:div (-> props
            (dissoc :icon-props)
            (update :class #(clsx "bg-[#4f4f4f]/20 text-[#4f4f4f] p-1 rounded-xs" %)))
   [:> Shapes (-> default-icon-props
                  (merge (:icon-props props)))]])

(defn data-apps-icon []
  [:div {:class "inline-block bg-kleene-dark-03/20 dark:text-kleene-dark-05 dark:bg-kleene-dark-05/20 text-kleene-dark-03 p-1 rounded-xs"}
   [:> LayoutGrid {:size 20 :strokeWidth 2.1 :class "block"}]])

(def dashboard-routes
  {:data-apps-acquisition-market-view
   {:title       "Paid marketing view"
    :description "Key marketing metrics"
    :icon        acquisition-icon
    :sigma-id    "2-1B1TVAKsCZSU3jUGq2tLPK"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/3iQOkwIjVXbKv2S05535LQ"
    :card        {:title       "Paid Marketing View"
                  :img         (img-url "acquisition" "marketing-view")
                  :modal       (docs-url "acquisition" "marketing-view")
                  :description "Consolidated view of all marketing activity. See all the key marketing metrics to understand performance e.g. ROAS, CAC and CTR."}}

   :data-apps-acquisition-audience-ai
   {:title       "Audiences"
    :description "Identify and target valuable marketing audiences"
    :icon        acquisition-icon
    :sigma-id    "2-1B1TVAKsCZSU3jUGq2tLPK"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/23Ouj8eVVefNMimELbjzhL"
    :card        {:img         (img-url "acquisition" "audience-ai")
                  :modal       (docs-url "acquisition" "audience-ai")
                  :description "Use AI to identify and target marketing activities towards valuable audiences across organic, paid and influencer channels."}}

   :data-apps-acquisition-spend-optimisation
   {:title       "Spend optimisation (Direct)"
    :description "Redistribute your marketing budget"
    :icon        acquisition-icon
    :sigma-id    "1-2oiF3cVKdglhQK63cMALs1"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/29lZnRQpRnQwb0e7sQx6Pi"
    :card        {:img         (img-url "acquisition" "spend-optimisation")
                  :modal       (docs-url "acquisition" "spend-optimisation")
                  :description "Re-distribute your marketing budget to maximise your return on marketing spend by using advanced attribution and marginal analysis."}}

   :data-apps-customers-customer-view
   {:title       "Single customer view"
    :description "Key customer metrics"
    :icon        customers-icon
    :sigma-id    "2-1B1TVAKsCZSU3jUGq2tLPK"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/3yeTK3ur0vmwD16uOSfr8a"
    :card        {:img         (img-url "customers" "single-customer-view")
                  :modal       (docs-url "customers" "single-customer-view")
                  :description "Consolidated view of all customers broken down by characteristics, behaviour and value. See all the key customer metrics to understand performance e.g. churn, AOV and re-purchase rate."}}

   :data-apps-customers-ai-segmentation
   {:title       "Segmentation"
    :description "Tailor engagement towards distinct customer segments"
    :icon        customers-icon
    :sigma-id    "2-1B1TVAKsCZSU3jUGq2tLPK"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/72NIJY0hc8CVgG2Y0JGD0D"
    :card        {:img         (img-url "customers" "ai-segmentation")
                  :modal       (docs-url "customers" "ai-segmentation")
                  :description "Use AI clustering to identify distinct customer segments, understand the characteristics, behaviour and value of each segment, then tailor engagements to each segment."}}

   :data-apps-customers-churn-prediction
   {:title       "Churn prediction"
    :description "Identify customers who are showing signs of churning"
    :icon        customers-icon
    :sigma-id    "2-1B1TVAKsCZSU3jUGq2tLPK"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/69qDj7yXtlCvgSZjDoAupw"
    :card        {:img         (img-url "customers" "churn-prediction")
                  :modal       (docs-url "customers" "churn-prediction")
                  :description "Minimise lost revenue and increase LTV by targeting re-engagement activity at customers who are showing signs of churning."}}

   :data-apps-products-product-view
   {:title       "Single product view"
    :description "Key product metrics"
    :icon        products-icon
    :sigma-id    "1-n6eWCCfjVruTOOnmvARGy"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/4qN6jtc6MFoItUmeNbLTQI"
    :card        {:img         (img-url "products" "single-product-view")
                  :modal       (docs-url "products" "single-product-view")
                  :description "Consolidated view of all products. See all the key product metrics to understand performance across SKUs, categories and options. Identify cross-sell, upsell and bundling opportunities."}}

   :data-apps-products-demand
   {:title       "Store replenishment"
    :description "Forecast demand and manage stock levels across stores"
    :icon        products-icon
    :sigma-id    "1-5rq9GmF7pBb9sZ5jKcmdbB"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/6CtJxV2Dr5nstXNeg02iFx"
    :userbacked  true
    :card        {:img         (img-url "products" "demand-forecasting")
                  :modal       (docs-url "products" "demand-forecasting")
                  :description "Forecast demand and manage stock levels across all your stores to avoid costly stock outs."}}

   :data-apps-products-inventory
   {:title       "Inventory management"
    :description "Forecast and manage your inventory requirements"
    :icon        products-icon
    :userbacked  true
    :sigma-id    "1-27em1Hhng65v0MKMFQjtdM"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/Inventory-Management-Demo-4vhLu5baYIaL1waAgGI7J4"
    :card        {:img         (img-url "products" "inventory-management")
                  :modal       (docs-url "products" "inventory-management")
                  :description "Forecast and manage your inventory requirements to minimise stock holding while avoiding costly stock outs. Then upload purchase orders directly to your ERP."}}

   :data-apps-management-scorecard
   {:title       "Balance scorecard"
    :description "An end to end overview of your business performance."
    :icon        products-icon
    :sigma-id    "1-2zNNer7KLwWd0AacuuuC30"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/5e8oyNnWYpSm8gXlR54kid"
    :card        {:img         (img-url "products" "inventory-management")
                  :modal       (docs-url "management" "scorecard")
                  :description "An end to end overview of your business performance."}}

   :data-apps-management-sales
   {:title       "Sales"
    :description "View sales performance by geography and product category with date comparison."
    :icon        products-icon
    :sigma-id    "1-7csWLnC6fZegmkTGy8alYa"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/24POsomFf7DBj8as11NAED"
    :card        {:title       "Retail sales performance"
                  :img         (img-url "products" "inventory-management")
                  :modal       (docs-url "management" "sales")
                  :description "View sales performance by geography and product category with date comparison."}}

   :data-apps-management-hubspot
   {:title       "Hubspot"
    :description "Campaign comparison and custom campaign builder for email campaign analysis."
    :icon        products-icon
    :sigma-id    "1-4MlIwiO5c6iLZrbhJnLB7D"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/2FU4a5NFoyS4XXu1OGh2ex"
    :card        {:title       "Hubspot campaign analysis"
                  :img         (img-url "products" "inventory-management")
                  :modal       (docs-url "management" "hubspot")
                  :description "Campaign comparison and custom campaign builder for email campaign analysis."}}


   ;; Demo agriculture apps
   :data-apps-agriculture-futures
   {:title       "Futures Open Position"
    :description "Uncover the variation margin and commodity prices over time"
    :icon        agriculture-icon
    :sigma-id    "1-74mPvtalMjFVVU2fFfpyvr"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/6gt3zOi4ERGJ73h4Usdllg"
    :card        {:img         (img-url "customers" "single-customer-view")
                  :modal       (docs-url "agriculture" "futures")
                  :description "Understand your market:\n1. Overview of variation margin and lots by account and commodity\n2. Delve into the variation in sugar prices over time and by market"}}

   :data-apps-agriculture-contracts-overview
   {:title       "Contracts Overview"
    :description "Uncover the value behind your contracts and track any changes"
    :icon        agriculture-icon
    :sigma-id    "1-5hdMfNlorr1dDYO5fb1Ggb"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/1Jc6Hy4j23EQWjlwfFuBO7"
    :card        {:img         (img-url "customers" "ai-segmentation")
                  :modal       (docs-url "agriculture" "contracts-overview")
                  :description "Have a full picture to understand your current contracts:\n1. Overview of performance, broken down by key dimensions\n2. Understand any changes to contracts that affect their overall value"}}

   :data-apps-agriculture-market-analysis
   {:title       "Market Analysis & Scenario Planning"
    :description "Understand the impact of FX rates and Commodity prices on your contracts"
    :icon        agriculture-icon
    :sigma-id    "1-2laX1WC1BMBT6H33159MG5"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/4XnwkDrolDUNpWPvAZXLgU"
    :card        {:img         (img-url "customers" "churn-prediction")
                  :modal       (docs-url "agriculture" "market-analysis")
                  :description "Plan for the worst, strive for the best:\n1. Compare actual contract values to the best-case and worst-case scenarios\n2. Input values for FX rates and Commodity prices and compare them to your current contract values"}}

   :data-apps-agriculture-trading-analysis
   {:title       "Physicals Trading Analysis"
    :description "Showcasing more ITAS data capabilities"
    :icon        agriculture-icon
    :sigma-id    "1-5L1wQCEDtQgv1IdT4l6qVE"
    :sigma-url   "https://app.sigmacomputing.com/kleene-partner/workbook/2aRKEMjNBOasPFOv4PrEN"
    :card        {:img         (img-url "customers" "churn-prediction")
                  :modal       (docs-url "agriculture" "trading-analysis")
                  :description "A view of Physical Trades containing contract details, quantities and prices. Daily deltas are included. Amounts are visualised for easier consumption."}}

   :data-apps-workbook
   {:title       "My reports"
    :description "Custom reports made by you"
    :icon        misc-icon
    :sigma-id    (fn []
                   (let [url @(re-posh/subscribe [:data-app/prop [:data-app/data-app-id "workbook"] :data-app/dashboard-url])]
                     (-> url
                         (s/split #"/")
                         last)))
    :sigma-url   (fn []
                   @(re-posh/subscribe [:data-app/prop [:data-app/data-app-id "workbook"] :data-app/dashboard-url]))
    :userbacked  true
    :data-app    false
    :workbook    true}})

(defn flags-checker [flag]
  @(re-posh/subscribe [:unleash/is-enabled flag]))

(defn section-enabled?
  "When none of the :enabled-flags and :disabled-flags is present, it means the section should be visible."
  [{:keys [enabled-flags disabled-flags]}]

  (let [disabled? (if (empty? disabled-flags)
                    false
                    (some true? (map flags-checker disabled-flags)))
        enabled?  (if (empty? enabled-flags)
                    true
                    (some true? (map flags-checker enabled-flags)))]
    (and enabled? (not disabled?))))


(defn cards-data []
  (filterv
   section-enabled?
   [{:title  "Acquisition"
     :icon   acquisition-icon
     :disabled-flags ["fe.data-apps-agriculture"]
     :colors ["#FFC606" "#FBDC5F"]
     :cards  [:data-apps-acquisition-spend-optimisation
              :data-apps-acquisition-audience-ai
              :data-apps-acquisition-market-view]}
    {:title  "Products"
     :icon   products-icon
     :disabled-flags ["fe.data-apps-agriculture"]
     :colors ["#d4daf1" "#4f6ce2"]
     :cards  [:data-apps-products-demand
              :data-apps-products-inventory
              :data-apps-products-product-view]}
    {:title  "Customers"
     :icon   customers-icon
     :disabled-flags ["fe.data-apps-agriculture"]
     :colors ["#ADE3CE" "#408D71"]
     :cards  [:data-apps-customers-ai-segmentation
              :data-apps-customers-churn-prediction
              :data-apps-customers-customer-view]}
    {:title  "Management"
     :icon   management-icon
     :disabled-flags ["fe.data-apps-agriculture"]
     :colors ["#C3ECF3" "#3F9BA9"]
     :cards  [:data-apps-management-scorecard
              :data-apps-management-hubspot
              :data-apps-management-sales]}

    {:title  "Agriculture"
     :icon   agriculture-icon
     :enabled-flags ["fe.data-apps-agriculture"]
     :colors ["#ADE3CE" "#408D71"]
     :cards  [:data-apps-agriculture-futures
              :data-apps-agriculture-contracts-overview
              :data-apps-agriculture-market-analysis
              :data-apps-agriculture-trading-analysis]}]))
